import { Box, ToggleButton, ToggleButtonGroup } from '@mui/material';
import React, { useEffect } from 'react';
import useLayoutStyles from '../../layout/useLayoutStyles';
import NotificationsTabPanel from './notificationsTabPanel';
import useNotificationsPageStyles from './useNotificationPageStyles';
import { Notification, User } from '../../../types';
import { currentUserSelector, setCurrUser } from '../../../redux/slices/userSlice';
import { useAppDispatch, useAppSelector } from '../../../redux/hooks';
import useUserContext from '../../../hooks/useUserContext';
import GameParrot from '../gameParrot';
import { setHeaderTitle } from '../../../redux/slices/layoutSlice';

/**
 * NotificationsPage component renders a page displaying personal and follower notifications
 * based on selected tabs.
 */
const NotificationsPage = () => {
  const [view, setView] = React.useState(0);
  const { socket } = useUserContext();
  const dispatch = useAppDispatch();
  const { classes } = useNotificationsPageStyles();
  const { classes: layoutClasses } = useLayoutStyles();
  const currentUser = useAppSelector(currentUserSelector);
  const [personalNotifications, setPersonalNotifications] = React.useState<Notification[]>([]);
  const [followerNotifications, setFollowerNotifications] = React.useState<Notification[]>([]);
  const viewTypes = ['My Feed', 'Following Activity'];

  useEffect(() => {
    dispatch(setHeaderTitle('Notifications'));
  }, [dispatch]);

  useEffect(() => {
    if (currentUser) {
      const updatedPersonalNotifications = currentUser.notifications
        .filter(notification => notification.receiver?._id === currentUser?._id)
        .reverse();
      const updatedFollowerNotifications = currentUser.notifications
        .filter(
          notification =>
            notification.sender?._id !== currentUser?._id &&
            updatedPersonalNotifications.indexOf(notification) === -1,
        )
        .reverse();
      setPersonalNotifications(updatedPersonalNotifications);
      setFollowerNotifications(updatedFollowerNotifications);
    }
  }, [currentUser]);

  const handleChange = (event: React.SyntheticEvent, newView: number) => {
    if (newView === null) return;
    setView(newView);
  };

  useEffect(() => {
    const handleUserNotificationUpdate = (updatedUser: User) => {
      if (updatedUser._id === currentUser?._id) {
        dispatch(setCurrUser({ identifier: updatedUser._id || '', idType: '_id' }));
      }
    };
    socket.on('userNotificationUpdate', handleUserNotificationUpdate);
    return () => {
      socket.off('userNotificationUpdate', handleUserNotificationUpdate);
    };
  }, [socket, dispatch, currentUser?._id]);
  return (
    <>
      <div className={layoutClasses.container}>
        <div className={`${layoutClasses.spaceBetween} ${layoutClasses.rightPadding}`}>
          <div className={layoutClasses.boldTitle}>Notifications</div>
          <ToggleButtonGroup
            value={view}
            exclusive
            aria-label='notification type'
            onChange={handleChange}
            className={classes.btns}>
            {[0, 1].map(order => (
              <ToggleButton
                className={classes.btn}
                key={order}
                value={order}
                selected={view === order}
                aria-label={viewTypes[order]}>
                {viewTypes[order]}
              </ToggleButton>
            ))}
          </ToggleButtonGroup>
          <div></div>
        </div>
        <Box className={classes.notificationsBox}>
          <NotificationsTabPanel index={0} value={view} notifications={personalNotifications} />
          <NotificationsTabPanel index={1} value={view} notifications={followerNotifications} />
        </Box>
      </div>
      <GameParrot />
    </>
  );
};

export default NotificationsPage;
